import { render, staticRenderFns } from "./ManualReminderForm.vue?vue&type=template&id=169ad13a&scoped=true&"
import script from "./ManualReminderForm.vue?vue&type=script&lang=js&"
export * from "./ManualReminderForm.vue?vue&type=script&lang=js&"
import style0 from "./ManualReminderForm.vue?vue&type=style&index=0&id=169ad13a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169ad13a",
  null
  
)

export default component.exports